export default __webpack_public_path__ + "static/media/3816.d65462de.png";